module.exports = __webpack_public_path__ + "img/arrow_left.f1af5e40.svg";